var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "text-danger field-validation-error",
      attrs: { "data-valmsg-replace": "true", "data-valmsg-for": _vm.fieldName }
    },
    [_c("span", [_vm._v("\n        " + _vm._s(_vm.message) + "\n    ")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }